import moment from 'moment';
import {Calendar, momentLocalizer, Views} from 'react-big-calendar';
import {useEffect, useState} from "react";
import {grey} from '@mui/material/colors';

import useWindowDimensions from '../../hooks/useWindowDimensions';
import SessionLabel from "./SessionLabel";
import ShiftLabel from "./ShiftLabel";
import Loader from "../Loader"
import {SIMPLE_TIME_FORMAT} from "../../config/DateTimeConstants"
import {SESSION_TYPE} from "../../domain/SessionType";
import {getEndTime, getContentHeight} from "../../helpers/SessionHelper";
import ShiftCalendarToolbar from './ShiftCalendarToolbar';

export default function ShiftCalendar({timeslotEvents, shiftEvents, calendarStepSize, handleNavigation, handleSelectEvent}) {
    
    const TIMESLOT_BACKGROUND_COLOR = grey[300];
    const BREAK_BACKGROUND_COLOR = grey[400];
    const SLOTS_IN_CALENDAR_STEP = 1;

    const localizer = momentLocalizer(moment);
    const {windowHeight} = useWindowDimensions();
    const [firstShiftStartTime, setFirstShiftStartTime] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const calendarHeight = {
        height: getContentHeight(windowHeight)
    };

    useEffect(() => {
        setIsLoading(!shiftEvents);
    }, [shiftEvents]);

    useEffect(() => {
        const todayEvents = shiftEvents?.filter(event => moment(event.start).isSame(moment(), 'day'));
        todayEvents?.sort((shift1, shift2) => moment(shift1.start).diff(moment(shift2.start)));

        const isAnyShiftPresentToday = todayEvents?.length > 0
        let scrollTime = moment().startOf('day');

        if (isAnyShiftPresentToday) {
            scrollTime = moment(todayEvents[0].start);
        }

        setFirstShiftStartTime(scrollTime.toDate());
    }, [shiftEvents]);
    
    const sessionStyle = (event, start, end, isSelected) => {

        const timeslotStartTime = moment.utc(event.start, SIMPLE_TIME_FORMAT);
        const timeslotEndTime = moment.utc(getEndTime(event.end), SIMPLE_TIME_FORMAT);

        const currentTime = moment.utc();
        const isTimeslotInProgress = currentTime.isAfter(timeslotStartTime) && currentTime.isBefore(timeslotEndTime);

        let customBorderStyle = event.primaryColor ? `1px solid ${event.primaryColor}` : "none";
        let customBackgroundColor = event.primaryColor;
        let customFontColor = 'white';

        if (isSelected) {
            customBorderStyle = `2px dotted black`;
        } else if (isTimeslotInProgress) {
            customBorderStyle = `2px solid black`;
        }

        if (Array.isArray(event.primaryColor) && event.primaryColor.length > 1) {
            customBackgroundColor = TIMESLOT_BACKGROUND_COLOR;
            customFontColor = 'black';
        }

        if (event.sessionType === SESSION_TYPE.BREAK) {
            customBackgroundColor = BREAK_BACKGROUND_COLOR;
        }

        if (event.sessionType === SESSION_TYPE.TRAINING) {
            customBackgroundColor = BREAK_BACKGROUND_COLOR;
        }

        if (event.sessionType === SESSION_TYPE.CHECK_IN) {
            customBackgroundColor = BREAK_BACKGROUND_COLOR;
        }

        let timeslotBackgroundStyle = {
            backgroundColor: customBackgroundColor,
            border: customBorderStyle,
            color: customFontColor
        }

        return {
            className: "",
            style: timeslotBackgroundStyle
        };
    }

    const eventLabel = ({event}) => {

        return (
            <>
                {event.isSession
                    ? <SessionLabel event={event} shiftEvents={shiftEvents}/>
                    : <ShiftLabel event={event}/>
                }
            </>
        );
    };

    return <>
        {isLoading
          ? <Loader/>
          : <Calendar
            className='rbc-time-view'
            localizer={localizer}
            defaultView={Views.DAY}
            events={timeslotEvents}
            backgroundEvents={shiftEvents}
            step={calendarStepSize}
            timeslots={SLOTS_IN_CALENDAR_STEP}
            style={calendarHeight}
            eventPropGetter={sessionStyle}
            onNavigate={handleNavigation}
            onSelectEvent={handleSelectEvent}
            views={['day']}
            scrollToTime={firstShiftStartTime}
            tooltipAccessor={null}
            components={{ 
                event: eventLabel, 
                toolbar: (toolbarProps) => (
                    <ShiftCalendarToolbar toolbar={toolbarProps}/>
                )
            }}
            dayLayoutAlgorithm="no-overlap"
          />
        }
    </>;
}